import { ReactPlugin } from '@21st-extension/react'
import { TwentyFirstToolbar } from '@21st-extension/toolbar-react'
import LoadingSpinner from '@components/common/LoadingSpinner'
import HomePage from '@pages/HomePage'
import { lazy, Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'

// HomePage는 즉시 로드, 나머지 페이지는 lazy load
const CreateEventPage = lazy(() => import('@pages/CreateEventPage'))
const EventViewPage = lazy(() => import('@pages/EventViewPage'))
const HostConsolePage = lazy(() => import('@pages/HostConsolePage'))
const EventManagePage = lazy(() => import('@pages/EventManagePage'))
const PreviewPage = lazy(() => import('@pages/PreviewPage'))

function App() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-white to-blue-50">
      <TwentyFirstToolbar
        config={{
          plugins: [ReactPlugin],
        }}
      />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route
          path="/create"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <CreateEventPage />
            </Suspense>
          }
        />
        <Route
          path="/host"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <HostConsolePage />
            </Suspense>
          }
        />
        <Route
          path="/host/:adminToken"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <EventManagePage />
            </Suspense>
          }
        />
        <Route
          path="/r/:shareToken"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <EventViewPage />
            </Suspense>
          }
        />
        <Route
          path="/preview/:adminToken"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <PreviewPage />
            </Suspense>
          }
        />
      </Routes>
    </div>
  )
}

export default App
